module.exports = __webpack_public_path__ + "img/netherlands-flag.3e94078.png";